var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsDepartments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 4H10c-3.315 0-6 2.685-6 6v10c0 3.307 2.688 6 6 6h10c3.305 0 6-2.695 6-6V10c0-3.312-2.693-6-6-6zM10 8h10c1.1 0 2 .899 2 2v10c0 1.095-.905 2-2 2H10c-1.101 0-2-.9-2-2V10c0-1.105.895-2 2-2zm27 18h-6c-2.765 0-5 2.235-5 5v6c0 2.75 2.24 5 5 5h6c2.745 0 5-2.255 5-5v-6c0-2.76-2.25-5-5-5zm-6 4h6c.544 0 1 .454 1 1v6c0 .535-.465 1-1 1h-6c-.546 0-1-.456-1-1v-6c0-.555.445-1 1-1zm8-22h-6c-2.765 0-5 2.235-5 5v6c0 2.75 2.24 5 5 5h6c2.745 0 5-2.255 5-5v-6c0-2.76-2.25-5-5-5zm-6 4h6c.544 0 1 .454 1 1v6c0 .535-.465 1-1 1h-6c-.546 0-1-.456-1-1v-6c0-.555.445-1 1-1zM19 28h-6c-2.765 0-5 2.235-5 5v6c0 2.75 2.24 5 5 5h6c2.745 0 5-2.255 5-5v-6c0-2.76-2.25-5-5-5zm-6 4h6c.544 0 1 .454 1 1v6c0 .535-.465 1-1 1h-6c-.546 0-1-.456-1-1v-6c0-.555.445-1 1-1z",
    fill: "#9EA2FA",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsDepartments);
export default __webpack_public_path__ + "static/media/icons-departments.c1abfe9b9c75877fabe186c8ce2cb5e6.svg";
export { ForwardRef as ReactComponent };